import {css} from "@panda/css";

/**
 * Column override for the offer grid when the AI advisor sidebar permanently reserves its rail on
 * desktop (see `OfferListView` `isSidebarReserved`). Applied to the `ColumnList` `Row` via
 * `rowClassName`, it sizes the grid items (`> li`) per viewport so they never end up crammed once the
 * ~520px sidebar gutter is reserved.
 *
 * Pure CSS (no JS measurement) so the column count is correct on the SSR / first paint and the listing
 * never reflows after hydration (CLS fix). The viewport bands mirror the legacy
 * `useFloatingSemanticSearchSidebarWidth` thresholds (content width 680 / 920 / 1240px) translated to
 * viewport width given the reserved gutter:
 *  - < 1200px            → content < 680px   → 1 column
 *  - 1200px – 1439px     → content 680–919px → 2 columns
 *  - 1440px – 1943px     → content 920–1239px→ 3 columns
 *  - >= 1944px           → content >= 1240px → 4 columns (the default `<Col lg={4}>`, no override)
 *
 * `.reservedGridRow > li` (specificity 0,1,1) wins over the Emotion `<Col>` rules (0,1,0), so the
 * override applies to every grid child — offer tiles, ad placements and promo tiles alike.
 */
export const reservedGridRowStyle = css({
    "& > li": {
        "@media (max-width: 1199px)": {
            flex: "1 0 100%",
            maxWidth: "100%"
        },
        "@media (min-width: 1200px) and (max-width: 1439px)": {
            flex: "1 0 50%",
            maxWidth: "50%"
        },
        "@media (min-width: 1440px) and (max-width: 1943px)": {
            flex: "1 0 33.3333%",
            maxWidth: "33.3333%"
        }
    }
});
import {css} from "@panda/css";

/**
 * Column override for the offer grid when the AI advisor sidebar permanently reserves its rail on
 * desktop (see `OfferListView` `isSidebarReserved`). Applied to the `ColumnList` `Row` via
 * `rowClassName`, it sizes the grid items (`> li`) per viewport so they never end up crammed once the
 * ~520px sidebar gutter is reserved.
 *
 * Pure CSS (no JS measurement) so the column count is correct on the SSR / first paint and the listing
 * never reflows after hydration (CLS fix). The viewport bands mirror the legacy
 * `useFloatingSemanticSearchSidebarWidth` thresholds (content width 680 / 920 / 1240px) translated to
 * viewport width given the reserved gutter:
 *  - < 1200px            → content < 680px   → 1 column
 *  - 1200px – 1439px     → content 680–919px → 2 columns
 *  - 1440px – 1943px     → content 920–1239px→ 3 columns
 *  - >= 1944px           → content >= 1240px → 4 columns (the default `<Col lg={4}>`, no override)
 *
 * `.reservedGridRow > li` (specificity 0,1,1) wins over the Emotion `<Col>` rules (0,1,0), so the
 * override applies to every grid child — offer tiles, ad placements and promo tiles alike.
 */
export const reservedGridRowStyle = css({
    "& > li": {
        "@media (max-width: 1199px)": {
            flex: "1 0 100%",
            maxWidth: "100%"
        },
        "@media (min-width: 1200px) and (max-width: 1439px)": {
            flex: "1 0 50%",
            maxWidth: "50%"
        },
        "@media (min-width: 1440px) and (max-width: 1943px)": {
            flex: "1 0 33.3333%",
            maxWidth: "33.3333%"
        }
    }
});
